export const users = [
  {
    work: {
      id: 1,
      position: "DevOps Engineer",
      Company: "Murex",
      Location: "Iraq",
      EmplomentType: "Full-Time",
      EmplomentDate: "2015-06-21",
    },
    education: {
      id: 2,
      University: "Salahaddin",
      Major: "Front-End Developer",
      EducationDate: "2014-01-07",
    },
  },
];
